import { useContext } from "react";
import { SidebarContext } from "../contexts/SidebarContext.js";

const useSidebar = () => useContext(SidebarContext);

export default useSidebar;
